<template>
  <div class="bpo-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="breadcrumbItem in breadcrumbItems"
        :to="breadcrumbItem.to"
        :key="breadcrumbItem.key"
        :style="{fontWeight: breadcrumbItem.isBorder?'border':'normal'}"
      >{{breadcrumbItem.label}}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'SWSBreadcrumb',
  props: {
    breadcrumbItems: Array
  }
}
</script>

<style scoped>
.bpo-breadcrumb {
  width: 100%;
  text-align: center;
}

.el-breadcrumb__item:first-child {
  margin-left: 15px;
}
</style>
